export default __webpack_public_path__ + "static/media/aboutus.a87cc6be.png";